<template>
  <div id="app" v-cloak>
    <div class="list">
      <ul>
        <li v-for="item of list" @click="go(item)">
          <p>{{item.title}}</p>
          <span>{{item.path}}</span>
          <div v-if="item.xcxpath != ''" class="slide_cl_xcx" :path="item.xcxpath"></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
Vue.config.ignoredElements = ['wx-open-launch-weapp']
export default {
  data: function () {
    return {
      list: []
    }
  },
  mounted: function () {
    this.init()
  },
  methods: {
    init: function () {
      this.getData()
    },
    getData: function () {
      var that = this
      this.$customRequestAjax(this.$ajax.getExclusiveList_URL).then(function (res) {
        if (res.data.code == 200) {
          that.list = res.data.list
          that.list.map(function (item) {
            item.xcxpath = ''
            if (item.type == 5) {
              item.xcxpath = '/pages/personalcenter/pages/livelist/main.html'
            } else if (item.type == 7) {
              var customParams = encodeURIComponent(JSON.stringify({
                type: 'live',
                live_id: item.liveid,
                exclusiveid: item.exclusiveid
              }))
              item.xcxpath = '__plugin__/wx2b03c6e691cd7370/pages/live-player-plugin.html?room_id=' + item.roomid + '&custom_params=' + customParams
            }
          })
          setTimeout(function () {
            that.goXcxCreateBtnFn()
          }, 500)
        }
      })
    },
    goXcxCreateBtnFn: function () {
      this.$nextTick(function () {
        var slideClXcx = document.getElementsByClassName('slide_cl_xcx')
        console.log('slideClXcx1', slideClXcx)
        for (var i = 0; i < slideClXcx.length; i++) {
          console.log('slideClXcx[i].attributes.path.value', slideClXcx[i].attributes.path.value)
          if (slideClXcx[i].attributes.path.value) {
            var script = document.createElement('script')
            script.type = 'text/wxtag-template'
            script.text = `<div style="width: ${slideClXcx[i].clientWidth}px; height: ${slideClXcx[i].clientHeight}px" class="box"></div>`
            slideClXcx[i].innerHTML = `<wx-open-launch-weapp
                      style="display:block; width:100%;height:100%;"
                      id="launch-btn${i}"
                      username="gh_5d4bb8e18b8b"
                      path="${slideClXcx[i].attributes.path.value}"
                    >${script.outerHTML}</wx-open-launch-weapp>`
          }
        }
      })
    },
    go: function (item) {
      var sign = item.path.indexOf('?') == -1 ? '?' : '&'
      window.location.href = item.path + sign + 'isshare=' + item.isshare
    }
  }
}
</script>

<style scoped lang="scss">
  body {
    background: #eeeeee;
  }
  .list {
    padding-bottom: 0.1rem;
  }
  .list ul li {
    background: #ffffff;
    margin: 0.1rem 0.1rem 0;
    padding: 0.1rem 0.11rem;
    border-radius: 0.06rem;
    position: relative;
    .slide_cl_xcx{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 100;
    }
  }
  .list ul li p {
    font-size: 0.16rem;
    color: #333333;
  }
  .list ul li span {
    font-size: 0.13rem;
    color: #cccccc;
    display: block;
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/exclusivelist/exclusivelist.vue